import { API_URL } from '../circulusConfig';
import { encodeGetParams /* getHeaders */ } from '../common/util';
// import { POST, PATCH, PUT } from '../common/consts';

// http://192.168.31.159:57793/v1/dashboard/in?institution=대구지방청
const getInstitutionListAPI = async () => {
  const res = await fetch(`${API_URL}dashboard/list`);
  const result = res.json();
  return result;
};
const getInitialDataAPI = async ({ institution, id }) => {
  const res = await fetch(
    `${API_URL}dashboard/in?${encodeGetParams({ institution, id })}`,
  );
  const result = res.json();
  return result;
};
const getStatusOfManagerAPI = async ({ institution }) => {
  const res = await fetch(
    `${API_URL}dashboard/status/manager?${encodeGetParams({ institution })}`,
  );
  const result = res.json();
  return result;
};
const getStatusOfDialogsAPI = async ({ robots }) => {
  const res = await fetch(
    `${API_URL}dashboard/status/dialogs?${encodeGetParams({ robots })}`,
  );
  const result = res.json();
  return result;
};
const getStatusOfAlertsAPI = async ({ robots }) => {
  const res = await fetch(
    `${API_URL}dashboard/status/alerts?${encodeGetParams({ robots })}`,
  );
  const result = res.json();
  return result;
};
const getUsageByRobotAPI = async ({ type, robots }) => {
  const res = await fetch(
    `${API_URL}dashboard/usage/robot/${type}?${encodeGetParams({ robots })}`,
  );
  const result = res.json();
  return result;
};
const getUsageByTimeAPI = async ({ robots }) => {
  const res = await fetch(
    `${API_URL}dashboard/usage/time?${encodeGetParams({ robots })}`,
  );
  const result = res.json();
  return result;
};
const getUsageByMostUsedBotAPI = async ({ robots }) => {
  const res = await fetch(
    `${API_URL}dashboard/usage/bot/mostused?${encodeGetParams({ robots })}`,
  );
  const result = res.json();
  return result;
};
const getUsageByTopicAPI = async ({ robots }) => {
  const res = await fetch(
    `${API_URL}dashboard/usage/topic/care?${encodeGetParams({ robots })}`,
  );
  const result = res.json();
  return result;
};
const getUsageDetectedFaceAPI = async ({ robots }) => {
  const res = await fetch(
    `${API_URL}dashboard/usage/face/detected?${encodeGetParams({ robots })}`,
  );
  const result = res.json();
  return result;
};
const getUsagePurposeByBotAPI = async ({ robots }) => {
  const res = await fetch(
    `${API_URL}dashboard/usage/bot/purpose?${encodeGetParams({ robots })}`,
  );
  const result = res.json();
  return result;
};

export {
  getInstitutionListAPI,
  getInitialDataAPI,
  getStatusOfManagerAPI,
  getStatusOfDialogsAPI,
  getUsageByRobotAPI,
  getUsageByTimeAPI,
  getUsageByMostUsedBotAPI,
  getStatusOfAlertsAPI,
  getUsageByTopicAPI,
  getUsageDetectedFaceAPI,
  getUsagePurposeByBotAPI,
};
